import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import { VDataTable, VDataTableServer, VDataTableVirtual, VDatePicker } from 'vuetify/components';
import * as directives from 'vuetify/directives';

import '../scss/main.scss';

export default createVuetify({
    theme: {
        defaultTheme: 'custom',
        themes: {
            custom: {
                dark: false,
                colors: {
                    background: '#FFFFFF',
                    surface: '#FFFFFF',
                    primary: '#1976d2',
                    'primary-darken-1': '#005eb6',
                    secondary: '#424242',
                    'secondary-darken-1': '#2c2c2c',
                    error: '#ff5252',
                    info: '#2196f3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                }
            }
        }
    },
    components: {
        ...components,
        VDataTable,
        VDataTableServer,
        VDataTableVirtual,
        VDatePicker
    },
    directives
});
